export default __webpack_public_path__ + "static/media/menu.3fcd8c44.svg";